import React from "react";
import { Link } from "react-router-dom";
import LegalPageLayout from "./LegalPageLayout";
import C from "./legal.config";

export default function WithdrawalPolicy() {
  return (
    <LegalPageLayout title="Cancellation &amp; Refunds" version={C.versions.withdrawal}>
      <p>
        This page describes your right to cancel a subscription and
        request a refund. It complements the{" "}
        <Link to="/legal/subscriptions" className="underline">Subscription Terms</Link>{" "}
        and the <Link to="/legal/terms" className="underline">Terms of Service</Link>.
      </p>

      <h2 className="legal-h2">1. Self-service cancellation (anytime)</h2>
      <p>
        You can cancel any subscription at any time from your account:{" "}
        <em>Profile → Billing → Manage subscription</em>. Cancellation
        stops future renewals but does not refund the current period —
        you keep PRO features until the end of the billing period you
        already paid for.
      </p>

      <h2 className="legal-h2">2. Refund policy</h2>
      <p>
        Because LEAGUE HUB is a digital service delivered immediately,
        we do not generally offer refunds for periods you have already
        accessed. However, we will issue a refund in the following
        circumstances:
      </p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>You were charged in error</strong> — duplicate billing, charged after a cancellation, or technical issue prevented access for the period charged.</li>
        <li><strong>Provincial consumer-protection law requires it</strong> — e.g. where applicable law provides a statutory cooling-off period for distance contracts and the carve-out for digital services delivered immediately does not apply.</li>
        <li><strong>Goodwill</strong> — we may issue a one-time discretionary refund or credit in cases of clear customer dissatisfaction. This is not a contractual right.</li>
      </ul>

      <h2 className="legal-h2">3. Express consent to immediate delivery</h2>
      <p>
        When you start a subscription, you expressly acknowledge that
        the digital service begins immediately and that — to the
        extent permitted by applicable law — you waive any statutory
        cancellation period in respect of the portion of the service
        you have already accessed. This is the standard "digital
        services" carve-out under most Canadian provincial
        consumer-protection regimes.
      </p>

      <h2 className="legal-h2">4. How to request a refund</h2>
      <p>
        Email <a href={`mailto:${C.contact_email}`}>{C.contact_email}</a>{" "}
        from the address linked to your account, include the
        approximate charge date and amount, and explain why you are
        requesting a refund. We aim to respond within{" "}
        <strong>5 business days</strong>. Approved refunds are
        processed via Stripe to the original payment method within
        5–10 business days of approval.
      </p>

      <h2 className="legal-h2">5. EU/UK consumers</h2>
      <p>
        If you are a consumer in the EU or UK, you have a 14-day right
        of withdrawal under the Consumer Rights Directive. By starting
        the subscription you may have expressly waived this right
        (see §3 above) to the extent the service has already been
        performed. Where it still applies, you may withdraw by emailing{" "}
        <a href={`mailto:${C.contact_email}`}>{C.contact_email}</a>{" "}
        within 14 days of subscribing.
      </p>

      <h2 className="legal-h2">6. Promo codes</h2>
      <p>
        Promotional codes have no cash value and cannot be refunded.
        If a code grants PRO time and you cancel before it expires,
        the remaining time is forfeited.
      </p>

      <p className="text-white/45 text-xs">
        Last updated: {C.last_updated}.
      </p>
    </LegalPageLayout>
  );
}
